export const FETCH_SUBSKILL_REQUEST = 'FETCH_SUBSKILL_REQUEST';
export const FETCH_SUBSKILL_SUCCESS = 'FETCH_SUBSKILL_SUCCESS';
export const FETCH_SUBSKILL_FAILED = 'FETCH_SUBSKILL_FAILED'; 

export const GET_SUBSKILL_GROUP = 'GET_SUBSKILL_GROUP';

export const SORT_SUBSKILL_ASC = 'SORT_SUBSKILL_ASC';
export const SORT_SUBSKILL_DESC = 'SORT_SUBSKILL_DESC';

export const SEARCH_SUBSKILL = 'SEARCH_SUBSKILL';
export const SEARCH_SUBSKILL_DEPARTMENT = 'SEARCH_SUBSKILL_DEPARTMENT';